const popupTriggerBlock = (editor, options) => {
  const popupBlockOptions = options.blocks["popup-trigger"];
  const { name, label, category } = popupBlockOptions;

  const popupTriggerstyles = options.components["popup-trigger"].style;

  const bm = editor.BlockManager;

  bm.add(name, {
    media: `<i class="fa fa-code"></i>`,
    label: `${label}`,
    category: category,
    content: {
      type: name,
      style: popupTriggerstyles
    }
  });
};

export default popupTriggerBlock;
